import { render, staticRenderFns } from "./ProgramContent.vue?vue&type=template&id=bb415b94&scoped=true&"
import script from "./ProgramContent.vue?vue&type=script&lang=js&"
export * from "./ProgramContent.vue?vue&type=script&lang=js&"
import style0 from "./ProgramContent.vue?vue&type=style&index=0&id=bb415b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb415b94",
  null
  
)

export default component.exports